import React from 'react'
import moment from 'moment'

interface IProps {
  eventDate: string,
  isMobile: boolean,
  returnPlainText?:boolean
}
const CountUpTimer: React.FC<IProps> = (props) => {
  const { eventDate } = props

  const [timer, setTimer] = React.useState<any>('0')

  React.useEffect(() => {
    const timeGap = moment().valueOf() - moment(eventDate).valueOf()

    const initialValues = {
      milliseconds: 0,
      seconds: Number(moment(timeGap).format('ss')),
      minutes: Number(moment(timeGap).format('mm')),
      hours: Number(moment(timeGap).format('hh'))
    }

    let [
      milliseconds,
      seconds,
      minutes,
      hours
    ]: [number, number, number, number] = [0, initialValues.seconds, initialValues.minutes, initialValues.hours];

    function displayTimer() {
      milliseconds+=10;
      if(milliseconds === 1000){
        milliseconds = 0;
        seconds++;
        if(seconds === 60){
          seconds = 0;
          minutes++;
          if(minutes === 60){
            minutes = 0;
            hours++;
          }
        }
      }
      let h = hours < 10 ? "0" + hours : hours;
      let m = minutes < 10 ? "0" + minutes : minutes;
      let s = seconds < 10 ? "0" + seconds : seconds;

      setTimer(`${h}:${m}:${s}`)
    }

    const interval = setInterval(displayTimer, 10);

    return () => clearInterval(interval);
  }, [eventDate])

  return (
    <div className="container">
      <div className="timerDisplay">
        { timer }
      </div>
    </div>
  )
}

export default CountUpTimer
